import { render, staticRenderFns } from "./DepositPanel.vue?vue&type=template&id=4f38dcea"
import script from "./DepositPanel.vue?vue&type=script&lang=ts"
export * from "./DepositPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports